/* =========================================================
   - Auto add/remove coolbox (49088827359531) based on __checkWeight line item property
   - Recalculate required boxes per 7.5kg (minimum 1 box if any cold items exist)
   - Hooks into fetch + XHR cart mutations so it updates without page reload
   ========================================================= */

document.addEventListener("DOMContentLoaded", () => {

  function addCoolboxClass() {
    // Find all cart items with the coolbox variant ID and add "coolbox" class (for styling)
    const boxVariantId = "49088827359531";
    const cartItems = document.querySelectorAll(
      `[data-variant-id="${boxVariantId}"], [data-id="${boxVariantId}"]`
    );

    cartItems.forEach((item) => {
      const cartItem = item.closest(
        ".cart-item, .cart__item, [class*='cart-item'], [class*='item']"
      );
      if (cartItem && !cartItem.classList.contains("coolbox")) {
        cartItem.classList.add("coolbox");
      }
    });
  }

/**
 * Refresh Shopify cart sections so UI stays in sync
 * This is required because cart/change.js and cart/add.js
 * do NOT automatically re-render the cart HTML.
 */
/**
 * Refresh ALL cart-dynamic sections on the cart page.
 * This keeps the UI in sync after background cart mutations (add/change).
 */
function refreshCartSections() {
  // Collect all section ids used on the cart page (items, summary, footer, etc.)
  const sectionIds = Array.from(
    document.querySelectorAll("cart-dynamic[data-section-id]")
  )
    .map((el) => el.getAttribute("data-section-id"))
    .filter(Boolean);

  // Fallback if nothing was found for some reason
  if (!sectionIds.length) sectionIds.push("api--cart--items");

  const url = `/?sections=${encodeURIComponent(sectionIds.join(","))}`;

  return fetch(url, { cache: "no-store" })
    .then((response) => response.json())
    .then((sections) => {
      sectionIds.forEach((id) => {
        const html = sections[id];
        if (!html) return;

        // Parse returned HTML
        const wrapper = document.createElement("div");
        wrapper.innerHTML = html;

        // Find the new <cart-dynamic> for this section id
        const newDynamic = wrapper.querySelector(
          `cart-dynamic[data-section-id="${id}"]`
        );
        const currentDynamic = document.querySelector(
          `cart-dynamic[data-section-id="${id}"]`
        );

        // Replace existing section with the new one
        if (newDynamic && currentDynamic) {
          currentDynamic.replaceWith(newDynamic);
        }
      });
    });
  }


  function checkBoxWeight() {
  // Single-flight + queued rerun to avoid race conditions
  if (window.__dsCoolboxRunActive) {
    window.__dsCoolboxRunQueued = true;
    return Promise.resolve();
  }
  window.__dsCoolboxRunActive = true;
  window.__dsCoolboxRunQueued = false;

  const BOX_VARIANT_ID = 49088827359531; // Coolbox variant ID
  const BOX_CAPACITY_KG = 7.5;          // One box per 7.5 kg

  // Always fetch the most recent cart state (avoid cached / stale responses)
  function fetchCartFresh() {
    return fetch("/cart.js", { cache: "no-store" }).then(r => r.json());
  }

  function tolerantIsChecked(item) {
    const val = item && item.properties && item.properties.__checkWeight;
    return (
      val === true ||
      val === "true" ||
      val === "True" ||
      val === "1" ||
      val === 1
    );
  }

  function afterCartMutation() {
  return fetchCartFresh().then((c) => {
    if (typeof window.updateWeight === "function") {
      window.updateWeight(c.total_weight);
    }

    return refreshCartSections().then(() => {
      setTimeout(() => {
        if (typeof window.addCoolboxClass === "function") window.addCoolboxClass();
      }, 150);
    });
  });
  }



  function changeLineQuantity(lineKeyOrId, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKeyOrId, quantity })
    });
  }

  function addVariantQuantity(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity })
    });
  }

  // Main run
  return fetchCartFresh()
    .then((cart) => {
      let totalColdWeightKg = 0;
      let hasColdItems = false;

      let boxLineKey = null;
      let currentBoxQty = 0;

      cart.items.forEach((item) => {
        // Detect the coolbox line
        if (item.variant_id === BOX_VARIANT_ID) {
          boxLineKey = item.key; // safest for change.js
          currentBoxQty = item.quantity || 0;
        }

        // Cold item detection via property
        if (tolerantIsChecked(item)) {
          hasColdItems = true;
          const grams = (item.grams || 0) * (item.quantity || 0);
          totalColdWeightKg += grams / 1000;
        }
      });

      // Compute required boxes
      const requiredBoxes = hasColdItems
        ? Math.max(1, Math.ceil(totalColdWeightKg / BOX_CAPACITY_KG))
        : 0;

      // Nothing to do
      if (requiredBoxes === currentBoxQty) return;

      // Remove coolbox when no cold items left
      if (requiredBoxes === 0) {
        if (!boxLineKey) return; // no coolbox to remove
        return changeLineQuantity(boxLineKey, 0)
          .then(() => afterCartMutation());
      }

      // Add coolbox if missing
      if (requiredBoxes > 0 && !boxLineKey) {
        return addVariantQuantity(BOX_VARIANT_ID, requiredBoxes)
          .then(() => afterCartMutation());
      }

      // Update existing coolbox quantity
      if (requiredBoxes > 0 && boxLineKey) {
        return changeLineQuantity(boxLineKey, requiredBoxes)
          .then(() => afterCartMutation());
      }
    })
    .catch(console.error)
    .finally(() => {
      window.__dsCoolboxRunActive = false;

      // If something triggered while we were running, run once more with fresh cart
      if (window.__dsCoolboxRunQueued) {
        window.__dsCoolboxRunQueued = false;
        // Small delay to let theme finish re-rendering sections
        setTimeout(() => {
          try { window.checkBoxWeight && window.checkBoxWeight(); } catch (e) {}
        }, 200);
      }
    });
}


  window.updateWeight = function (totalWeight) {
    const total_weight = totalWeight / 1000;
    const shippingPriceElements = document.querySelectorAll("#ntv-region-shipping-price");

    var countryDPDFilter = document.allShippingRates.filter(
      (e) => e.Country_code == window.general.countryCode && e.Carrier == "DPD"
    );
    var countryFedexFilter = document.allShippingRates.filter(
      (e) => e.Country_code == window.general.countryCode && e.Carrier == "Fedex"
    );
    var countryPostNlFilter = document.allShippingRates.filter(
      (e) => e.Country_code == window.general.countryCode && e.Carrier == "Postnl"
    );

    var totalWeightElements = document.querySelectorAll("#ntv-header-total-weight");
    var totalWeightElementWrapper = document.querySelectorAll(".ntv-weight-to-add");

    if (total_weight > 0) {
      shippingPriceElements.forEach((element) => {
        element.classList.add("inline-block");
        element.classList.remove("hidden");
      });
      totalWeightElementWrapper.forEach((element) => {
        element.classList.add("inline-block");
        element.classList.remove("hidden");
      });

      var currentWeightRulePostNl = "";
      countryPostNlFilter.forEach(function (v) {
        var low_w = v.Minimal_weight;
        var high_w = v.Maximal_weight;
        if (total_weight <= high_w && total_weight >= low_w) {
          currentWeightRulePostNl = v;
        }
      });

      var currentWeightRuleFedex = "";
      countryFedexFilter.forEach(function (v) {
        var low_w = v.Minimal_weight;
        var high_w = v.Maximal_weight;
        if (total_weight <= high_w && total_weight >= low_w) {
          currentWeightRuleFedex = v;
        }
      });

      var currentWeightRuleDPD = "";
      countryDPDFilter.forEach(function (v) {
        var low_w = v.Minimal_weight;
        var high_w = v.Maximal_weight;
        if (total_weight <= high_w && total_weight >= low_w) {
          currentWeightRuleDPD = v;
        }
      });

      var data = [];
      if (currentWeightRuleFedex) data.push(currentWeightRuleFedex);
      if (currentWeightRulePostNl) data.push(currentWeightRulePostNl);
      if (currentWeightRuleDPD) data.push(currentWeightRuleDPD);

      data.sort(function (a, b) {
        var keyA = a.Price,
          keyB = b.Price;
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });

      var leastData = data.shift();

      if (leastData) {
        var price = leastData.Price;
        if (leastData.Price == undefined) {
          price = "-";
        }

        shippingPriceElements.forEach((element) => {
          element.innerHTML = "&euro; " + price;
        });

        var weightToBeAdded = (leastData.Maximal_weight - parseFloat(total_weight)).toFixed(2);
        if (weightToBeAdded == undefined || weightToBeAdded.toString() == "NaN") {
          weightToBeAdded = "-";
        }
        totalWeightElements.forEach((element) => {
          element.innerHTML = weightToBeAdded.toString();
        });
      }
    } else {
      shippingPriceElements.forEach((element) => {
        element.classList.remove("inline-block");
        element.classList.add("hidden");
      });
      totalWeightElementWrapper.forEach((element) => {
        element.classList.remove("inline-block");
        element.classList.add("hidden");
      });
    }
  };

  // Run on initial page load
  checkBoxWeight();
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      window.updateWeight(cart.total_weight);
      setTimeout(() => addCoolboxClass(), 150);
    });

  // If your theme emits this event, keep supporting it
  document.addEventListener("cart:update", () => {
    checkBoxWeight();
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        window.updateWeight(cart.total_weight);
        setTimeout(() => addCoolboxClass(), 150);
      });
  });

  // Expose functions so the global cart hook (below) can call them
  window.checkBoxWeight = checkBoxWeight;
  window.addCoolboxClass = addCoolboxClass;

  /* =========================================================
     Mobile arrow functionality for slider
     ========================================================= */
  function initMobileSliderArrows() {
    const mobileArrows = document.querySelectorAll(".mobile-arrow");

    mobileArrows.forEach((arrow) => {
      const sliderId =
        arrow.getAttribute("data-slider-prev") || arrow.getAttribute("data-slider-next");
      const feed = document.querySelector(`[data-slider="${sliderId}"]`);
      if (!feed) return;

      // Set initial arrow visibility
      updateArrowVisibility(
        feed,
        document.querySelector(`[data-slider-prev="${sliderId}"]`),
        document.querySelector(`[data-slider-next="${sliderId}"]`)
      );

      // Update on scroll
      feed.addEventListener("scroll", function () {
        updateArrowVisibility(
          feed,
          document.querySelector(`[data-slider-prev="${sliderId}"]`),
          document.querySelector(`[data-slider-next="${sliderId}"]`)
        );
      });

      arrow.addEventListener("click", function () {
        const scrollAmount = feed.clientWidth;
        const isPrev = this.classList.contains("mobile-arrow--prev");

        feed.scrollBy({
          left: isPrev ? -scrollAmount : scrollAmount,
          behavior: "smooth"
        });
      });
    });
  }

  function updateArrowVisibility(feed, prevArrow, nextArrow) {
    if (!prevArrow || !nextArrow) return;

    const scrollLeft = feed.scrollLeft;
    const maxScrollLeft = feed.scrollWidth - feed.clientWidth;

    // Hide prev arrow on first slide
    if (scrollLeft <= 0) {
      prevArrow.style.opacity = "0";
      prevArrow.style.pointerEvents = "none";
    } else {
      prevArrow.style.opacity = "1";
      prevArrow.style.pointerEvents = "auto";
    }

    // Hide next arrow on last slide
    if (scrollLeft >= maxScrollLeft - 1) {
      nextArrow.style.opacity = "0";
      nextArrow.style.pointerEvents = "none";
    } else {
      nextArrow.style.opacity = "1";
      nextArrow.style.pointerEvents = "auto";
    }
  }

  function initSnapSliderArrows() {
    const snapSliderWrappers = document.querySelectorAll(".snap-slider-wrapper");

    snapSliderWrappers.forEach((wrapper) => {
      const arrows = wrapper.querySelectorAll(".mobile-arrow");
      const feed = wrapper.querySelector("[data-slider]");
      if (!feed || arrows.length === 0) return;

      const prevArrow = wrapper.querySelector(".mobile-arrow--prev");
      const nextArrow = wrapper.querySelector(".mobile-arrow--next");

      updateArrowVisibility(feed, prevArrow, nextArrow);

      feed.addEventListener("scroll", function () {
        updateArrowVisibility(feed, prevArrow, nextArrow);
      });

      arrows.forEach((arrow) => {
        arrow.addEventListener("click", function () {
          const isPrev = this.classList.contains("mobile-arrow--prev");
          const scrollAmount = feed.clientWidth;

          feed.scrollBy({
            left: isPrev ? -scrollAmount : scrollAmount,
            behavior: "smooth"
          });
        });
      });
    });
  }

  initMobileSliderArrows();
  initSnapSliderArrows();

  /* =========================================================
     USP slider — true infinite loop on mobile (no visible jump)
     ========================================================= */
  (function initUspInfiniteMobile() {
    const slider = document.querySelector('snap-slider[data-id="sections--25976942461311__header"]');
    if (!slider) return;

    const feed = slider.querySelector("feed");
    if (!feed) return;

    const mq = window.matchMedia("(max-width: 1024px)");
    if (!mq.matches) return;

    if (feed.dataset.uspLoopInit === "1") return;
    feed.dataset.uspLoopInit = "1";

    slider.dataset.loop = "false";
    slider.dataset.autoplay = "false";

    const items = Array.from(feed.children).filter((el) => el.nodeType === 1);
    const count = items.length;
    if (count < 2) return;

    const firstClone = items[0].cloneNode(true);
    firstClone.setAttribute("data-clone", "true");
    feed.appendChild(firstClone);

    let index = 0;
    let timer = null;
    const interval = 3200;

    function width() {
      return feed.clientWidth;
    }

    function goTo(i, smooth = true) {
      const left = i * width();
      if (!smooth) {
        const prev = feed.style.scrollBehavior;
        feed.style.scrollBehavior = "auto";
        feed.scrollLeft = left;
        feed.style.scrollBehavior = prev || "";
        return;
      }
      feed.scrollTo({ left, behavior: "smooth" });
    }

    function tick() {
      index += 1;
      goTo(index, true);

      if (index === count) {
        window.setTimeout(() => {
          index = 0;
          goTo(0, false);
        }, 450);
      }
    }

    goTo(0, false);
    timer = window.setInterval(tick, interval);

    const pause = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    const resume = () => {
      if (!timer) timer = window.setInterval(tick, interval);
    };

    feed.addEventListener("touchstart", pause, { passive: true });
    feed.addEventListener("touchend", resume, { passive: true });

    window.addEventListener("resize", () => goTo(index, false));
  })();
});

/* =========================================================
   Toggle subcollections visibility
   ========================================================= */
window.toggleSubcollections = function (event) {
  event.preventDefault();
  const button = event.currentTarget;
  const wrapper = button.closest(".subcollections-grid-desktop");
  if (!wrapper) return;

  const hiddenItems = wrapper.querySelectorAll(".subcollection-item.hidden");
  const showMoreText = button.querySelector(".show-more-text");
  const showLessText = button.querySelector(".show-less-text");

  if (hiddenItems.length > 0) {
    // Show all hidden items
    hiddenItems.forEach((item) => item.classList.remove("hidden"));
    if (showMoreText) showMoreText.classList.add("hidden");
    if (showLessText) showLessText.classList.remove("hidden");
  } else {
    // Hide items after 7th
    const allItems = wrapper.querySelectorAll(".subcollection-item");
    allItems.forEach((item) => {
      if (parseInt(item.dataset.index, 10) > 7) item.classList.add("hidden");
    });
    if (showMoreText) showMoreText.classList.remove("hidden");
    if (showLessText) showLessText.classList.add("hidden");
  }
};

/* =========================================================
   Hook cart AJAX (fetch + XHR) so checkBoxWeight runs after cart mutations
   ========================================================= */
(function hookCartAjax() {
  // Prevent double install
  if (window.__dsCartHookInstalled) return;
  window.__dsCartHookInstalled = true;

  let scheduled = null;

  function scheduleCheck() {
    if (scheduled) clearTimeout(scheduled);

    // Wait a bit longer: themes often do 2-3 cart calls + section renders
    scheduled = setTimeout(() => {
      if (typeof window.checkBoxWeight !== "function") return;

      // Run now, and run again shortly after to catch late cart updates
      window.checkBoxWeight();
      setTimeout(() => window.checkBoxWeight(), 350);
    }, 250);
  }

  function extractUrl(input) {
    try {
      if (typeof input === "string") return input;
      if (input && typeof input.url === "string") return input.url; // Request
      if (input instanceof URL) return input.toString();
    } catch (e) {}
    return "";
  }

  function isCartMutation(url) {
    // Shopify Ajax API endpoints that mutate cart
    return (
      url.includes("/cart/add") ||
      url.includes("/cart/change") ||
      url.includes("/cart/update") ||
      url.includes("/cart/clear")
    );
  }

  // Hook fetch
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = extractUrl(args[0]);
    const p = originalFetch.apply(this, args);

    if (url && isCartMutation(url)) {
      p.then(scheduleCheck).catch(() => {});
    }
    return p;
  };

  // Hook XHR
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__dsCartUrl = typeof url === "string" ? url : "";
    return originalOpen.call(this, method, url, ...rest);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    try {
      if (this.__dsCartUrl && isCartMutation(this.__dsCartUrl)) {
        this.addEventListener("loadend", scheduleCheck);
      }
    } catch (e) {}
    return originalSend.apply(this, args);
  };

  // Also react to theme event if it exists
  document.addEventListener("cart:update", scheduleCheck);
})();
document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#cart_form");
  if (!form) return;

  const label = form.querySelector('label[for="discount"]');
  if (!label) return;

  // De rij met input + knop ("Activeren")
  const row = label.nextElementSibling && label.nextElementSibling.matches(".flex")
    ? label.nextElementSibling
    : null;

  if (!row) return;
  if (form.querySelector(".cart-discount")) return;

  // Marker: onthoud waar het blok stond
  const marker = document.createComment("discount-marker");
  form.insertBefore(marker, label);

  // Wrapper + toggle + panel
  const wrapper = document.createElement("div");
  wrapper.className = "cart-discount";

  const toggle = document.createElement("button");
  toggle.type = "button";
  toggle.className = "cart-discount__toggle";
  toggle.setAttribute("aria-expanded", "false");

  const title = document.createElement("span");
  title.className = "title";
  title.textContent = "Heb je een kortingscode?";

  const chev = document.createElement("span");
  chev.className = "chev";
  chev.setAttribute("aria-hidden", "true");

  toggle.appendChild(title);
  toggle.appendChild(chev);

  const panel = document.createElement("div");
  panel.className = "cart-discount__panel";

  // Verplaats bestaande elementen in panel
  panel.appendChild(label);
  panel.appendChild(row);

  wrapper.appendChild(toggle);
  wrapper.appendChild(panel);

  // Plaats wrapper terug op originele plek
  form.insertBefore(wrapper, marker.nextSibling);
  marker.remove();

  const setOpen = (open) => {
    wrapper.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
  };

  toggle.addEventListener("click", () => {
    setOpen(!wrapper.classList.contains("is-open"));
  });

  // Auto-open regels:
  const input = wrapper.querySelector("#discount");
  const hasValue = input && input.value && input.value.trim().length > 0;

  // Als foutmelding zichtbaar is (caption-message niet hidden)
  const caption = wrapper.querySelector('caption-message[for="discount"]');
  const hasErrorVisible = caption && !caption.classList.contains("hidden");

  // Open als al ingevuld / error
  if (hasValue || hasErrorVisible) setOpen(true);
});

